<!-- <div [ngClass]="{'modal-active': uiService.modalInstances.length > 0}">
  <a (click)="skipLink($event)" class="btn btn-primary btn-primary--small skip-link" href="#main">Skip to main content</a> -->

<!-- <app-modal *ngFor="let modal of uiService.modalInstances">
    <ng-template *ngComponentOutlet="modal.component"></ng-template>
  </app-modal> -->

<app-global-header (onMenuOpen)="sidebar.toggleMenu()" (logoutEvent)="logout()"></app-global-header>
<div class="container">
  <div class="sidebar" [ngClass]="{close: sidebar.isMenuClosed, 'hide-sidebar': isSidebarHidden && sidebar.isMenuClosed}">
    <app-sidebar #sidebar></app-sidebar>
  </div>
  <main class="mainSection" [class.enrollmentMainSection]="isSidebarHidden">
    <router-outlet></router-outlet>
  </main>
</div>